import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TripTypeSelector } from './TripTypeSelector';
import {
    TripType,
    getCMSTripTypes
} from '../../models';
import { TripTypeSelectorButton } from './TripTypeSelectorMobile.style';
import { ABUtils } from '../../utils';
import { isTrainsProductActive } from '../../redux/currentSearch/selectors';


export const TripTypeSelectorMobile = () => {
    const { t } = useTranslation();
    const { isCssVariationMobile } = ABUtils.getABs();
    const tripTypes = Object.values(TripType);
    const isTrainsProduct = useSelector((state) => isTrainsProductActive(state));
    if (isTrainsProduct) {
        tripTypes.splice(tripTypes.indexOf(TripType.MULTIPLE), 1);
    }
    const groupClassNames = classNames({
        'odf-btn-group': !isCssVariationMobile,
        'prisma-btn-group': isCssVariationMobile,
    });

    const renderItem = (value, onChange) => (
        <div className={groupClassNames} style={{ display: 'flex' }}>
            {tripTypes.map((tripType) => {
                const isSelected = tripType === value;
                const className = classNames({
                    'odf-btn': !isCssVariationMobile,
                    'odf-btn-ghost-light': !isCssVariationMobile && !isSelected,
                    'odf-btn-primary selected': !isCssVariationMobile && isSelected,
                    'prisma-btn prisma-btn-sm': isCssVariationMobile,
                    'prisma-btn-default': isCssVariationMobile && !isSelected,
                    'prisma-btn-active selected': isCssVariationMobile && isSelected,
                    'odf-text-condensed': isCssVariationMobile,
                });
                return (
                    <TripTypeSelectorButton
                        htmlFor={`tripTypeSwitcher_${tripType}`}
                        key={tripType}
                        type="button"
                        className={className}
                        onClick={() => onChange(tripType)}
                    >
                        <span dangerouslySetInnerHTML={{ __html: `${t(getCMSTripTypes()[tripType])}` }} />
                    </TripTypeSelectorButton>
                );
            })}
        </div>
    );

    return (
        <TripTypeSelector
            render={renderItem}
        />
    );
};
